import { Box, Button, Grid, ListItemIcon, MenuItem } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";

export default function NonEditableTable({ columns, data, additionalProps }) {
  return (
    <Box sx={{ "& td": { p:1,pl:1.5, borderRight: "1px solid #ddd" } }}>
      <MaterialReactTable
        columns={columns}
        data={data}
        editDisplayMode="table"
        enableEditing={false}
        enableColumnActions={false}
        enableRowActions={false}
        // positionActionsColumn="last"
        // enableTopToolbar={enableTopToolbar ?? true}
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: {
              sx: {
                backgroundColor: "var(--pv-table-header-bg)",
              },
            },
            muiTableBodyCellProps: {
              sx: {
                textAlign: "center",
                "& td": {
                  borderRight: "1px solid #ddd",
                },
                "& button": {
                  m: 1,
                },
              },
            },
          },
        }}
        state={
          {
            //   isLoading
            // showProgressBars: isLoading ? true : false
          }
        }
        muiTableHeadCellProps={({ cell }) => ({
          sx: {
            borderRight: "1px solid var(--pv-table-border)",
            backgroundColor: "var(--pv-table-header-bg)",
            // fontSize: "16px",
            // display: "flex",
            // alignItems: "center",
            // px: 0,
            pt: 2,
          },
        })}
        {...additionalProps}
      />
    </Box>
  );
}
